module.exports = __webpack_public_path__ + "assets/img/personal.e52833c3.png";